"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewStripeWebhook extends new_item_1.default {
    constructor(newStripeWebhook) {
        super();
        this.body = newStripeWebhook.body;
    }
}
exports.default = NewStripeWebhook;
//# sourceMappingURL=new-stripeWebhook.js.map